<template>
    <div class="modal" v-bind:class="modalClass">
        <div id="modal-overlay" @click="back()"></div>
        <article id="modal-edit">
            <header>
                <figure><i class="icon icon-icon_person"></i></figure>
                <div>
                    <span class="breadcrumb">
                        Attribute <i class="icon icon-icon_arrow-right"></i> importation
                    </span>
                    <h1>Importation</h1>
                </div>
                <div class="spacer"></div>
                <div>
                    <button @click="back()" class="bt-back"><span><i class="icon icon-icon_arrow-left"></i></span></button>
                    <button @click="back($event)" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                </div>
            </header>

            <div>

                <input class="input" type="file" id="import" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv">
                <button @click="upload($event)"><span>Upload</span></button>

                <div v-if="totalRow" class="progress-bar">
                    <span>Current {{ currentRow }} of {{ totalRow }}</span>
                    <div class="bar">
                        <div v-bind:style="{width: (currentRow*100/totalRow) + '%'}">{{ Math.round((currentRow*100/totalRow)) }}%</div>
                    </div>
                </div>

                <div v-if="errors" class="log-errors">
                    <div v-for="error in errors">
                        {{ error }}
                    </div>
                </div>


            </div>

        </article>
    </div>
</template>
<script>

    import Service from './AttributeService.js';
    import Import from '../../../layouts/Import.vue';

    export default {
        extends: Import,
        data () {
            return {
                test: null,
                options: [],
                currentRow: 0,
                totalRow: 0,
                errors: [],
                dataToShow: {
                    name: 'root',
                    children: []
                }
            }
        },
        mounted: function(){
        },
        methods:{
            upload(e){
                let fileInput = document.getElementById( 'import' );
                let data = new FormData();
                data.append( 'file', fileInput.files[0] );
                data.append( 'start_at', this.currentRow );
                Service.import(data).then((response) => {

                    this.currentRow = response.data.current_row ? response.data.current_row : this.currentRow
                    this.totalRow = response.data.total ? response.data.total : this.totalRow

                    this.process(e);

                }, response => {
                    this.errors.push(response.data.message)
                })
            },
            process(e){
                if( this.totalRow <= this.currentRow ){ return true; }

                let data = new FormData();
                data.append( 'start_at', this.currentRow );
                data.append( 'file_name', document.getElementById( 'import' ).files[0].name );
                Service.import(data).then((response) => {

                    this.currentRow = response.data.current_row ? response.data.current_row : this.currentRow
                    this.totalRow = response.data.total ? response.data.total : this.totalRow

                    this.process(e);

                }, response => {
                    this.errors.push(response.data.message)

                    // continue
                    this.currentRow = this.currentRow + 1
                    this.process(e);
                })
            },
            getResource: function(){
                return {name: 'attribute', api: Service}
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/attribute/Import.vue